<header-row
   [userName]="'Victoria Brown'"
   [userRole]="'REGIONAL MANAGER'"></header-row>
<main
   *ngIf="!isLoading"
   class="page-layout">
   <section class="content-box">
      <mat-tab-group>
         <mat-tab label="Users">
            <header class="box-header">
               <h3>User Manager</h3>
               <div class="filters">
                  <button
                     class="submit-btn"
                     (click)="assiginUser()">
                     <span class="material-icons">add</span>
                     Assign User
                  </button>
               </div>
            </header>
            <div
               class="section-container mat-elevation-z1"
               style="margin-top: 30px"></div>
            <div class="section-container mat-elevation-z1">
               <div class="table-wrap">
                  <table
                     mat-table
                     [dataSource]="userDataSource"
                     matSort
                     #userSort="matSort"
                     class="data-table"
                     style="table-layout: fixed; width: 100%">
                     <ng-container matColumnDef="displayName">
                        <th
                           mat-header-cell
                           *matHeaderCellDef
                           mat-sort-header
                           style="width: 25%">
                           Display Name
                        </th>
                        <td
                           mat-cell
                           *matCellDef="let row">
                           <div style="display: flex; align-items: center; gap: 8px">
                              <span
                                 *ngIf="hasHospitalOverride(row.id)"
                                 class="material-icons override-flag"
                                 title="Hospital Assigned">
                                 push_pin
                              </span>
                              {{ row.displayName }}
                           </div>
                        </td>
                     </ng-container>
                     <ng-container matColumnDef="roleName">
                        <th
                           mat-header-cell
                           *matHeaderCellDef
                           mat-sort-header
                           style="width: 20%">
                           Role Name
                        </th>
                        <td
                           mat-cell
                           *matCellDef="let row">
                           <mat-chip>{{ row.roleName ? row.roleName : "N/A" }}</mat-chip>
                        </td>
                     </ng-container>
                     <ng-container matColumnDef="email">
                        <th
                           mat-header-cell
                           *matHeaderCellDef
                           mat-sort-header
                           style="width: 25%">
                           Email
                        </th>
                        <td
                           mat-cell
                           *matCellDef="let row">
                           {{ row.email ? row.email : "N/A" }}
                        </td>
                     </ng-container>
                     <ng-container matColumnDef="hospitalStatus">
                        <th
                           mat-header-cell
                           *matHeaderCellDef
                           mat-sort-header
                           style="width: 20%">
                           Hospital Assigned
                        </th>
                        <td
                           mat-cell
                           *matCellDef="let row">
                           <span
                              class="status-badge"
                              [ngClass]="hasHospitalOverride(row.id) ? 'active' : 'inactive'">
                              {{ hasHospitalOverride(row.id) ? "True" : "False" }}
                           </span>
                        </td>
                     </ng-container>
                     <ng-container matColumnDef="actions">
                        <th
                           mat-header-cell
                           *matHeaderCellDef
                           style="width: 15%">
                           Actions
                        </th>
                        <td
                           mat-cell
                           *matCellDef="let row">
                           <div style="display: flex; align-items: center; gap: 4px">
                              <button
                                 mat-icon-button
                                 color="accent"
                                 *ngIf="row.roleName === 'RM'"
                                 (click)="assignHospital(row)"
                                 title="Assign Hospital">
                                 <span class="material-icons">domain_add</span>
                              </button>
                              <button
                                 mat-icon-button
                                 color="primary"
                                 (click)="UnassignUserAccess(row)"
                                 title="Unassign Access">
                                 <span class="material-icons">manage_accounts</span>
                              </button>
                           </div>
                        </td>
                     </ng-container>

                     <tr
                        mat-header-row
                        *matHeaderRowDef="userDisplayedColumns"></tr>
                     <tr
                        mat-row
                        *matRowDef="let row; columns: userDisplayedColumns"></tr>
                  </table>
                  <mat-paginator
                     #userPaginator
                     [pageSize]="50"
                     [pageSizeOptions]="[10, 50, 100, 200, 500, 1000]"
                     showFirstLastButtons></mat-paginator>
               </div>
            </div>
         </mat-tab>
         <mat-tab label="Hospitals">
            <div
               class="section-container mat-elevation-z1"
               style="margin-top: 20px">
               <header class="box-header">
                  <h3>Hospital List</h3>

                  <div class="header-search">
                     <span class="p-input-icon-left search-field">
                        <input
                           pInputText
                           type="text"
                           class="search-input"
                           placeholder="Search Practices"
                           (input)="applyPracticeFilter($event)" />
                     </span>
                  </div>
               </header>

               <!-- <div>
            <button class="submit-btn" [disabled]="!isCriticalButtonEnabled" (click)="showPrimeDialog = true">
              Mark as Critical
            </button>
          </div> -->
               <div class="table-wrap">
                  <table
                     mat-table
                     [dataSource]="practiceDataSource"
                     matSort
                     #practiceSort="matSort"
                     class="data-table">
                     <ng-container matColumnDef="select">
                        <th
                           mat-header-cell
                           *matHeaderCellDef>
                           <span>Is Critical</span>
                        </th>
                        <td
                           mat-cell
                           *matCellDef="let row"
                           (click)="togglePracticeCritical(row)">
                           <mat-checkbox
                              [checked]="row.isCritical"
                              (click)="$event.stopPropagation()"
                              (change)="onPracticeCriticalChange(row, $event.checked)"></mat-checkbox>
                        </td>
                     </ng-container>
                     <ng-container matColumnDef="practiceSKey">
                        <th
                           mat-header-cell
                           *matHeaderCellDef
                           mat-sort-header
                           style="width: 10%">
                           Practice Key
                        </th>
                        <td
                           mat-cell
                           *matCellDef="let row">
                           {{ row.practiceSKey }}
                        </td>
                     </ng-container>
                     <ng-container matColumnDef="practiceName">
                        <th
                           mat-header-cell
                           *matHeaderCellDef
                           mat-sort-header
                           style="width: 60%">
                           Practice Name
                        </th>
                        <td
                           mat-cell
                           *matCellDef="let row">
                           {{ row.practiceName }}
                        </td>
                     </ng-container>
                     <ng-container matColumnDef="isCritical">
                        <th
                           mat-header-cell
                           *matHeaderCellDef
                           mat-sort-header
                           style="width: 15%">
                           Is Critical
                        </th>
                        <td
                           mat-cell
                           *matCellDef="let row">
                           <span
                              class="status-badge"
                              [ngClass]="row.isCritical ? 'active' : 'inactive'">
                              {{ row.isCritical ? "Yes" : "No" }}
                           </span>
                        </td>
                     </ng-container>
                     <tr
                        mat-header-row
                        *matHeaderRowDef="practiceDisplayedColumns"></tr>
                     <tr
                        mat-row
                        *matRowDef="let row; columns: practiceDisplayedColumns"></tr>
                     <tr
                        class="mat-row"
                        *matNoDataRow>
                        <td
                           class="mat-cell no-data-cell"
                           [attr.colspan]="practiceDisplayedColumns.length">
                           No Records Found
                        </td>
                     </tr>
                  </table>
                  <mat-paginator
                     #practicePaginator
                     [pageSize]="50"
                     [pageSizeOptions]="[10, 20, 50, 100, 200, 500, 1000]"
                     showFirstLastButtons></mat-paginator>
               </div>
            </div>
         </mat-tab>
      </mat-tab-group>
   </section>
</main>

<div
   *ngIf="isLoading"
   style="
      display: flex;
      align-items: center;
      justify-content: center;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.95);
      z-index: 9999;
   ">
   <div style="text-align: center">
      <img
         src="/assets/catSpinner.gif"
         style="width: 130px; margin-bottom: 20px" />
      <div style="color: #363636; font-size: 24px">Please wait...</div>
   </div>
</div>

<p-dialog
   header="Confirm Critical Hospital"
   [(visible)]="showPrimeDialog"
   [modal]="true"
   [closable]="false"
   [style]="{ width: '350px' }">
   <ng-template pTemplate="content">Are you sure you want to update the critical status for the selected hospital(s)?</ng-template>
   <ng-template pTemplate="footer">
      <button
         pButton
         type="button"
         label="Cancel"
         class="p-button-text"
         (click)="onPrimeDialogCancel()"></button>
      <button
         pButton
         type="button"
         label="Confirm"
         class="p-button-primary"
         (click)="onPrimeDialogConfirm()"></button>
   </ng-template>
</p-dialog>

<p-dialog
   header="Assign User"
   class="user-dialog"
   [(visible)]="showAssignUserDialog"
   [modal]="true"
   [closable]="false"
   [style]="{ width: '500px' }"
   *ngIf="!isAssignHospitalMode">
   <ng-template pTemplate="content">
      <div style="display: flex; flex-direction: column; gap: 15px">
         <div class="form-group">
            <label
               for="eligibleUserDropdown"
               style="font-weight: 600; margin-bottom: 5px; display: block">
               Select User
            </label>
            <p-dropdown
               inputId="eligibleUserDropdown"
               [options]="eligibleUserOptions"
               [(ngModel)]="selectedEligibleUser"
               (onChange)="onEligibleUserChange()"
               placeholder="Select user"
               [filter]="true"
               [showClear]="true"
               appendTo="body"
               (onFilter)="onEligibleUserFilter($event)"
               [style]="{ width: '100%' }"></p-dropdown>
            <small
               class="p-error"
               *ngIf="assignDialogSubmitted && !selectedEligibleUser">
               * Please select a user.
            </small>
         </div>

         <div class="form-group">
            <label
               for="userRoleDropdown"
               style="font-weight: 600; margin-bottom: 5px; display: block">
               Select User Role
            </label>
            <p-dropdown
               inputId="userRoleDropdown"
               [options]="userRoleOptions"
               [(ngModel)]="selectedUserRole"
               placeholder="Select user role"
               [filter]="true"
               [showClear]="true"
               appendTo="body"
               [style]="{ width: '100%' }"></p-dropdown>
            <small
               class="p-error"
               *ngIf="assignDialogSubmitted && selectedUserRole == null">
               * Please select a user role.
            </small>
         </div>
      </div>
   </ng-template>
   <ng-template pTemplate="footer">
      <button
         pButton
         type="button"
         label="Cancel"
         class="p-button-text"
         (click)="onAssignDialogCancel()"></button>
      <button
         pButton
         type="button"
         label="Assign"
         class="p-button-primary"
         [disabled]="isAssigningUser"
         (click)="onAssignDialogConfirm()"></button>
   </ng-template>
</p-dialog>

<p-dialog
   [(visible)]="showAssignUserDialog"
   [modal]="true"
   [closable]="false"
   [style]="{ width: '520px' }"
   *ngIf="isAssignHospitalMode">
   <ng-template pTemplate="header">
      <div style="display: flex; align-items: center; justify-content: space-between; width: 100%; margin: -16px 0px 0; padding: 12px 0px; border-bottom: 1px solid #e2e8f0;">
         <span style="font-size: 16px; font-weight: 600; color: #1e293b;">Assign Hospital</span>
         <button
            type="button"
            (click)="onAssignDialogCancel()"
            style="background: none; border: none; cursor: pointer; padding: 4px; display: flex; align-items: center; justify-content: center; border-radius: 4px; color: #64748b; transition: all 0.15s ease;"
            onmouseover="this.style.background='#f1f5f9'; this.style.color='#1e293b'"
            onmouseout="this.style.background='none'; this.style.color='#64748b'">
            <span class="material-icons" style="font-size: 20px;">close</span>
         </button>
      </div>
   </ng-template>
   <ng-template pTemplate="content">
      <div style="display: flex; flex-direction: column; gap: 16px; padding-top: 4px;">
         <div class="form-group">
            <label
               for="eligibleUserDropdownHospital"
               style="font-weight: 600; margin-bottom: 6px; display: block; font-size: 13px; color: #374151;">
               Select User
            </label>
            <p-dropdown
               inputId="eligibleUserDropdownHospital"
               [options]="eligibleUserOptions"
               [(ngModel)]="selectedEligibleUser"
               (onChange)="onEligibleUserChange()"
               placeholder="Select user"
               [filter]="true"
               [showClear]="true"
               appendTo="body"
               (onFilter)="onEligibleUserFilter($event)"
               [style]="{ width: '100%' }"></p-dropdown>
            <small
               class="p-error"
               *ngIf="assignDialogSubmitted && !selectedEligibleUser">
               * Please select a user.
            </small>
         </div>

         <div style="display: flex; gap: 10px;">
            <div style="flex: 1; min-width: 0;">
               <label
                  for="hospitalDropdown"
                  style="font-weight: 600; margin-bottom: 6px; display: block; font-size: 13px; color: #374151;">
                  Select Hospital
               </label>
               <p-dropdown
                  inputId="hospitalDropdown"
                  [options]="hospitalOptions"
                  [(ngModel)]="selectedHospital"
                  (onChange)="onHospitalSelect($event)"
                  placeholder="Select hospital"
                  [filter]="true"
                  [showClear]="true"
                  appendTo="body"
                  [style]="{ width: '100%' }">
                  <ng-template let-hospital pTemplate="item">
                     <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                        <span>{{ hospital.label }}</span>
                        <span *ngIf="hospital.value?.isOverride" class="material-icons" style="font-size: 16px; color: #4caf50;" title="Already assigned">check_circle</span>
                     </div>
                  </ng-template>
               </p-dropdown>
               <small
                  class="p-error"
                  *ngIf="assignDialogSubmitted && !selectedHospital">
                  * Please select a hospital.
               </small>
            </div>
            <button
               pButton
               type="button"
               label="Assign"
               icon="pi pi-plus"
               class="p-button-success"
               style="margin-top: 22px; white-space: nowrap;"
               [disabled]="isAssigningUser || !selectedHospital || !selectedEligibleUser"
               (click)="onAssignDialogConfirm()"></button>
         </div>

         <div>
            <label
               style="font-weight: 600; margin-bottom: 8px; display: block; font-size: 13px; color: #374151;">
               Assigned Hospitals
               <span
                  *ngIf="!isLoadingHospitals && assignedHospitals.length > 0"
                  style="font-weight: 400; color: #94a3b8; margin-left: 4px;">({{ assignedHospitals.length }})</span>
            </label>
            <div
               *ngIf="isLoadingHospitals"
               style="display: flex; align-items: center; justify-content: center; padding: 24px; background: #f8fafc; border-radius: 8px; border: 1px solid #e2e8f0;">
               <p-progressSpinner
                  [strokeWidth]="4"
                  [style]="{ width: '28px', height: '28px' }"></p-progressSpinner>
               <span style="margin-left: 10px; font-size: 13px; color: #64748b;">Loading hospitals...</span>
            </div>
            <div
               *ngIf="!isLoadingHospitals && assignedHospitals.length === 0"
               style="padding: 20px; background: #f8fafc; border-radius: 8px; color: #94a3b8; font-size: 13px; border: 1px dashed #e2e8f0; text-align: center;">
               No hospitals assigned yet.
            </div>
            <div
               *ngIf="!isLoadingHospitals && assignedHospitals.length > 0"
               style="display: flex; flex-direction: column; gap: 6px; max-height: 200px; overflow-y: auto;">
               <div
                  *ngFor="let hospital of assignedHospitals"
                  style="display: flex; align-items: center; justify-content: space-between; padding: 10px 12px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 8px; transition: all 0.15s ease;"
                  onmouseover="this.style.borderColor='#86efac'; this.style.background='#dcfce7'"
                  onmouseout="this.style.borderColor='#bbf7d0'; this.style.background='#f0fdf4'">
                  <div style="display: flex; align-items: center; gap: 10px; min-width: 0;">
                     <span class="material-icons" style="font-size: 18px; color: #16a34a; flex-shrink: 0;">check_circle</span>
                     <span style="font-size: 13px; font-weight: 500; color: #1e293b; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ hospital.practiceName }}</span>
                  </div>
                  <button
                     pButton
                     type="button"
                     icon="pi pi-trash"
                     class="p-button-text p-button-danger p-button-sm"
                     style="padding: 6px 8px; min-width: auto; flex-shrink: 0;"
                     pTooltip="Unassign"
                     tooltipPosition="top"
                     (click)="onUnassignHospitalClick(hospital)"></button>
               </div>
            </div>
         </div>
      </div>
   </ng-template>
</p-dialog>

<p-dialog
   header="Confirm Unassign User"
   [(visible)]="showUnassignUserDialog"
   [modal]="true"
   [closable]="false"
   [style]="{ width: '420px' }">
   <ng-template pTemplate="content">
      Are you sure you want to unassign access for
      <strong>{{ selectedUserForUnassign?.displayName || selectedUserForUnassign?.email || "this user" }}</strong>
      ?
   </ng-template>
   <ng-template pTemplate="footer">
      <button
         pButton
         type="button"
         label="Cancel"
         class="p-button-text"
         (click)="onUnassignDialogCancel()"></button>
      <button
         pButton
         type="button"
         label="Unassign"
         class="p-button-primary"
         [disabled]="isUnassigningUser"
         (click)="onUnassignDialogConfirm()"></button>
   </ng-template>
</p-dialog>

<p-dialog
   header="Confirm Unassign Hospital"
   [(visible)]="showUnassignHospitalDialog"
   [modal]="true"
   [closable]="false"
   [style]="{ width: '420px' }">
   <ng-template pTemplate="content">
      <div style="display: flex; flex-direction: column; gap: 12px;">
         <p style="margin: 0; color: #475569; line-height: 1.5;">
            Are you sure you want to unassign this hospital from
            <strong>{{ selectedEligibleUser?.displayName || selectedEligibleUser?.email || "this user" }}</strong>
            ?
         </p>
         <div style="display: flex; align-items: center; gap: 8px; padding: 10px 12px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 6px;">
            <span class="material-icons" style="font-size: 18px; color: #dc2626;">warning</span>
            <span style="font-weight: 600; color: #991b1b; font-size: 13px;">{{ selectedHospitalForUnassign?.practiceName }}</span>
         </div>
         <p style="margin: 0; font-size: 12px; color: #94a3b8;">
            The user will lose access to this hospital's goals, tasks, and meetings.
         </p>
      </div>
   </ng-template>
   <ng-template pTemplate="footer">
      <button
         pButton
         type="button"
         label="Cancel"
         class="p-button-text"
         (click)="onUnassignHospitalCancel()"></button>
      <button
         pButton
         type="button"
         label="Unassign"
         class="p-button-danger"
         [disabled]="isUnassigningHospital"
         (click)="onUnassignHospitalConfirm()"></button>
   </ng-template>
</p-dialog>
